module.exports = __webpack_public_path__ + "static/top-00edc59ac35b48c0b31f11c6ffc059d1.png";